const Systems ="bgautox" 

export default Systems;
